import { FormInformesMap, listaDeInformeEntryType, listaDeInformes } from "@/Routes/listaDeInformes";
import { IInforme, TipoInforme, informesConsultarPrecio, informesPrecios } from "../../../redux/models/typesInformes";
import { cloneElement, createContext, forwardRef, memo, useMemo, useRef, useState } from "react";
import { useReactToPrint } from "react-to-print";


export type InformeModes = 'editable' | 'view' | 'create' | 'carrito_editable' | 'admin-view'


export interface IFormInformeProps {
  onSubmit: (informe: IInforme) => void
  data?: unknown
  mode: InformeModes
}


/**
 * @description Component responsible for displaying any informe and make functional the actions
 * @input informeFormComponent
 * @output Form informe
 * @value informe: form who has the data of the informe
 */
export const InformeContext =
  createContext<{
    mode: InformeModes,
    data: IInforme | any,
    onCancel: () => void,
    title: string,
    keyVelocidad: any,
    precio: [number, React.Dispatch<React.SetStateAction<number>>]
    isConsultarPrecio: boolean,
    informe?: listaDeInformeEntryType,
    onPrint: () => void
  }>(
    {
      mode: 'create',
      data: {} as IInforme,
      onCancel: () => { },
      title: '',
      keyVelocidad: [],
      precio: [0, () => { }],
      isConsultarPrecio: false,
      onPrint: () => { }
    }
  )


const InformePrintable = forwardRef(({ Form, onSubmit, mode, data }: any, ref: any) => {

  return <section aria-label='printable-informe' ref={ref}
  > {cloneElement(<Form />, { onSubmit, mode, data })}
    <style>
      {`
          @media print {
            /* Estilos específicos para la impresión */
            body {
              font-size: 12pt;
              color: black;
            }

            section {
              /* Puedes añadir estilos adicionales específicos para la impresión aquí */
              padding-top: 30px;
              padding-left: 60px;
              padding-right: 60px;
            }
          }
        `}
    </style>
  </section>
});


const InformeRender = ({ data, onCancel, onSubmit, mode, formName, onPrinted }:
  {
    data?: IInforme,
    onCancel?: () => void,
    onSubmit?: (informe: IInforme) => void
    mode: InformeModes
    formName: string
    onPrinted?: () => void
  }) => {

  const precio = useState(0)

  const InformeFormComponent = useMemo(() => FormInformesMap.get(formName), [formName]);
  const informe = useMemo(() => listaDeInformes.find(i => i.ComponentName === formName), [formName]);

  const informeRef = useRef() as any;

  const onSend = (informe: IInforme) => {
    if (data?._id) {
      informe = { ...informe, _id: data._id }
    }
    onSubmit && onSubmit(informe)
  }

  const obtenerKeyVelocidad = () => {
    if (!informe) return []
    const tipoInforme = Object.keys(informe.tipos)[0];
    return informesPrecios[tipoInforme]
  }

  const getIsConsultarPrecio = () => {
    if (!informe) return false
    const tiposInforme = Object.keys(informe.tipos) as TipoInforme[]
    const hayConsultarPrecio = tiposInforme.some(tipo => informesConsultarPrecio.includes(tipo))
    return hayConsultarPrecio
  }

  const handlePrint = useReactToPrint({
    content: () => informeRef.current,
    onAfterPrint: () => {
      onPrinted && onPrinted()
    }
  })

  return <InformeContext.Provider value={{
    mode: mode,
    data: data as IInforme,
    onCancel: () => { onCancel && onCancel() },
    title: informe?.nombre as string,
    informe: informe,
    keyVelocidad: obtenerKeyVelocidad(),
    precio: useMemo(() => precio, [precio]),
    isConsultarPrecio: getIsConsultarPrecio(),
    onPrint: handlePrint

  }}>
    <InformePrintable
      ref={informeRef}
      Form={InformeFormComponent}
      onSubmit={onSend}
      mode={mode}
      data={data}
    />


  </InformeContext.Provider >
}






export default InformeRender;